"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    "spacing0": "0",
    "spacing2": "calc(0.2rem * var(--voca-rem-multiplier))",
    "spacing4": "calc(0.4rem * var(--voca-rem-multiplier))",
    "spacing8": "calc(0.8rem * var(--voca-rem-multiplier))",
    "spacing12": "calc(1.2rem * var(--voca-rem-multiplier))",
    "spacing16": "calc(1.6rem * var(--voca-rem-multiplier))",
    "spacing20": "calc(2rem * var(--voca-rem-multiplier))",
    "spacing24": "calc(2.4rem * var(--voca-rem-multiplier))",
    "spacing32": "calc(3.2rem * var(--voca-rem-multiplier))",
    "spacing48": "calc(4.8rem * var(--voca-rem-multiplier))",
    "spacing64": "calc(6.4rem * var(--voca-rem-multiplier))",
    "spacing80": "calc(8rem * var(--voca-rem-multiplier))",
    "spacing96": "calc(9.6rem * var(--voca-rem-multiplier))",
    "spacing128": "calc(12.8rem * var(--voca-rem-multiplier))"
};
exports.default = spacing;
